import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1/analysis";
const FALLBACK_MESSAGE = "\u062e\u0637\u0627 \u062f\u0631 \u0627\u0631\u062a\u0628\u0627\u0637 \u0628\u0627 \u0633\u0631\u0648\u0631";

const request = (path, options = {}) =>
  requestWithAuth(`${API_BASE}${path}`, options, { fallbackMessage: FALLBACK_MESSAGE });

export function getAccountChallenges() {
  return request("/account-challenges/");
}

export function getLiveAccounts() {
  return request("/live-accounts/");
}

export function getUserAccountsNumbers() {
  return request("/user-accounts/");
}

export function getBrokers() {
  return request("/brokers/");
}

export function updateChallengeBroker(challengeId, payload = {}) {
  return request(`/update-challenge-broker/${challengeId}/`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function getAccountChallengeDetail(accountNumber) {
  return request(`/account-challenge/${accountNumber}/`);
}

export function getBalanceEquityHistory(accountNumber) {
  return request(`/balance-equity-history/${accountNumber}/`);
}

export function getAccountAnalysis(accountNumber) {
  return request(`/account-analysis/${accountNumber}/`);
}

export function getTrades(accountNumber, params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });
  const qs = query.toString();
  const path = accountNumber ? `/trades/${accountNumber}/` : "/trades/";
  return request(`${path}${qs ? `?${qs}` : ""}`);
}
